import React, { useEffect, useState, useRef } from 'react';
import html2canvas from 'html2canvas';
import Charts from './Charts';

function ChartCapture({ isMobile, chartType, chartData, chartOptions, setChartUrl }) {
    const [isChartRendered, setIsChartRendered] = useState(false);
    const chartRef = useRef(null);

    const captureChart = async () => {
        const chartOuterDiv = chartRef.current.firstChild;
        const chartCanvas = chartOuterDiv.firstChild;
        const canvas = await html2canvas(chartCanvas);
        const dataUrl = canvas.toDataURL('image/png');
        // console.log(dataUrl);

        setChartUrl(dataUrl);
    };

    useEffect(() => {
        if(isChartRendered) {
            // Render and capture the chart automatically
            captureChart();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isChartRendered]);
    

    if(chartType && chartData && chartOptions) {
        return (
            <>
                {/* Hidden container for rendering the chart */}
                <div>
                    <div ref={chartRef}>
                        <Charts 
                            isMobile={isMobile} 
                            type={chartType} 
                            data={chartData} 
                            options={{ ...chartOptions, "animation": { onComplete: () => { setIsChartRendered(true); } } }} 
                        />
                    </div>
                </div>
            </>
        );
    } else {
        return(null);
    }
};

export default ChartCapture;